import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ValidationResult } from '../../../core/services/validation/models/validation-result';

@Component({
    selector: 'app-validation-error-list',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './validation-error-list.component.html',
})
export class ValidationErrorListComponent {
    @Input() validationResult!: ValidationResult;
}
